<div class="container-fluid mt-4" style="font-size: 15px">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h2>Surveys</h2>
        </div>

        <div class="card-body" *ngIf="surveys == null">
          <h4>Loading...</h4>
        </div>

        <div class="card-body" *ngIf="surveys != null">
          <div>
            <button class="btn btn-success btn-sm btn-spaced" (click)="createSurvey()">
              <fa-icon [icon]="['fal','plus']"></fa-icon>
              Create
            </button>
          </div>
          <div>
            <table class="table">
              <thead>
                <tr>
                  <th class="text-center">Title</th>
                  <th class="text-center">Questions</th>
                  <th class="text-center">Completions</th>
                  <th class="text-center">Start</th>
                  <th class="text-center">End</th>
                  <th class="text-left">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let s of surveys">
                  <td class="text-left">
                    <app-input-selector type="text" [value]="s.title" (update)="updateTitle(s, $event)"></app-input-selector>
                  </td>
                  <td class="text-center" style="cursor: pointer" (click)="editSurvey(s)">{{ s.setup?.entries?.length }}</td>
                  <td class="text-center">{{ s.evaluations }}</td>
                  <td class="text-center">
                    <app-input-selector
                      type="date"
                      [value]="s.start"
                      deletable="true"
                      (update)="updateStartDate(s, $event)"
                    ></app-input-selector>
                  </td>
                  <td class="text-center">
                    <app-input-selector
                      type="date"
                      [value]="s.end"
                      deletable="true"
                      (update)="updateEndDate(s, $event)"
                    ></app-input-selector>
                  </td>
                  <td class="text-left">
                    <button class="btn btn-info btn-sm btn-spaced" (click)="editSurvey(s)">
                      <fa-icon [icon]="['fal','cog']"></fa-icon>
                      Edit
                    </button>
                    <button class="btn btn-primary btn-sm btn-spaced" (click)="evaluateSurvey(s)" [disabled]="s.evaluations == 0">
                      <fa-icon [icon]="['fal','check']"></fa-icon>
                      Evaluate
                    </button>
                    <button class="btn btn-danger btn-sm btn-spaced" (click)="deleteSurvey(s)">
                      <fa-icon [icon]="['fal','trash']"></fa-icon>
                      Delete
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
